export const RouterLinks = {
  root: '/',

  login: '/auth/login',
  kycStatus: '/kyc-status',

  // registration
  signup: '/signup',
  registerationAccountType: '/signup/accounts/account-type',
  registerationTerms: '/signup/accounts/terms',
  registerationFCADetails: '/signup/accounts/advisor-details',
  registerationPersonalDetails: '/signup/accounts/registration',
  registerationVerification: '/signup/accounts/verification',
  registerationPasswordSetup: '/signup/accounts/password-set-up',
  signupSuccess: '/signup/success',

  // Register via Mail
  registerPersonalDetails: '/registration/main/personal-details',
  registerViaMailVerification: '/registration/main/verification',
  registerViaMailPasswordSetup: '/registration/main/password-set-up',

  // ONBOARDING ROUTES / PROFILE SETUP ROUTES
  personalDetails: '/onboarding/personal-details',
  expertiseDetails: '/onboarding/expertise-details',
  qualifications: '/onboarding/qualifications',
  accoladesUpload: '/onboarding/accolades-upload',
  workingPreferences: '/onboarding/working-preferences',
  clientData: '/onboarding/client-data',
  calenderSetup: '/onboarding/calendar-setup',
  notifications: '/onboarding/notifications',
  termsAndConditions: '/onboarding/terms-and-conditions',

  // MANAGE PORTFOLIO ROUTES
  managePortfolio: '/dashboard/manage-portfolio',
  previewCSV: '/dashboard/manage-portfolio/preview-csv',
  mps: '/dashboard/manage-portfolio/mps',
  mpsRebalancing: '/dashboard/manage-portfolio/rebalancing',

  // DASHBOARD ROUTES
  pricing: '/pricing',
  upgradePlan: '/upgrade-plan',
  dashboard: '/dashboard',
  dashboardLink: '/dashboard/dashboard',
  advisorCopilot: '/dashboard/copilot',
  meetings: '/dashboard/meetings',
  clients: '/dashboard/clients',
  paymentSuccess: '/complete-payment',
  support: '/dashboard/support',
  supportTicket: '/dashboard/support/ticket',
  training: '/dashboard/support/training',
  clientProfile: '/dashboard/client-profile',
  clientProfileAiAssistance: '/dashboard/ai-assistance',
  securedMessages: '/dashboard/secured-messages',
  inviteClient: '/dashboard/clients/invite-client',
  migrateClient: '/dashboard/clients/migrate-client',
  clientTasks: '/dashboard/client-tasks',
  protectionPlanning: '/dashboard/para-planner/protection-planning',

  selectPortfolio: '/dashboard/client-tasks/select-portfolio',
  protectionPlanningSolution: '/dashboard/para-planner/solution',
  customTask: '/dashboard/para-planner/custom-task',
  askAi: '/dashboard/ask-ai',
  askZeta: '/dashboard/ask-zeta',
  agentsConsumerDuty: '/dashboard/agents/consumer-duty',
  agentsIllustrations: '/dashboard/agents/illustrations',
  complianceReviews: '/dashboard/compliance/reviews',
  complianceNewReview: '/dashboard/compliance/new-review',
  complianceReviewDetails: '/dashboard/compliance/review-details',
  notificationsProfileSetup: '/dashboard/notifications',

  // MANAGED_CLIENT
  managedClientSecureMessage: '/dashboard/managed-client/secure-message',
  managedClientDocuments: '/dashboard/managed-client/documents',
  managedClientInitialMeetingSummary: '/dashboard/managed-client/initial-meeting-summary',
  managedClientPersonalInfo: '/dashboard/managed-client/personal-information',
  managedClientAssets: '/dashboard/managed-client/assets',
  managedClientProtectionSolution: '/dashboard/managed-client/protection-plan',
  managedClientInvestmentSolution: '/dashboard/managed-client/investment-plan',
  managedClientRetirementPlanning: '/dashboard/managed-client/retirement-planning',
  managedClientIncome: '/dashboard/managed-client/income',
  managedClientExpenditure: '/dashboard/managed-client/expenditure',
  managedClientRiskAssessment: '/dashboard/managed-client/risk-assessment',
  managedClientLiabilites: '/dashboard/managed-client/liabilities',
  managedClientHealthDetails: '/dashboard/managed-client/health-details',
  managedClientNominees: '/dashboard/managed-client/nominees',
  managedClientInteractionHub: '/dashboard/managed-client/client-interaction-hub',

  managedClientPortfolio: '/dashboard/managed-client/portfolio',
  managedClientPortfolioDetail: '/dashboard/managed-client/portfolio-detail',

  // from, these will be deleted
  // FACT-FIND ROUTES
  factFindDocuments: '/dashboard/client-info/documents',
  factFindInitialMeetingSummary: '/dashboard/client-info/discovery',
  factFindPersonalInfo: '/dashboard/fact-find/personal-information',
  factFindAssets: '/dashboard/fact-find/assets',
  factFindProtectionSolution: '/dashboard/fact-find/protection-solution',
  factFindExperience: '/dashboard/fact-find/experience',
  factFindSummaryAndNotes: '/dashboard/client-info/overview',
  factFindBeneficiaries: '/dashboard/fact-find/beneficiaries',
  factFindExpenditure: '/dashboard/fact-find/expenditure',
  factFindIncome: '/dashboard/fact-find/income',
  factFindNextSteps: '/dashboard/fact-find/next-steps',
  factFindInvestmentSolution: '/dashboard/fact-find/investment-solution',
  factFindBenefitsAndInsurance: '/dashboard/fact-find/benefits-and-insurance',
  factFindLiabilites: '/dashboard/fact-find/liabilities',
  factFindHealthDetails: '/dashboard/fact-find/health-details',
  factFindFinancialPlanning: '/dashboard/client-info/financial-planning-workspace',
  factFindRiskAssessment: '/dashboard/fact-find/risk-assessment',
  factFindGoalsAndTimeline: '/dashboard/client-info/financial-planning-workspace',
  factFindReview: '/dashboard/fact-find/review',
  factFindGenerateReport: '/dashboard/fact-find/generate-report',
  factFindClientInteractionHub: '/dashboard/fact-find/client-interaction-hub',
  // to, these will be deleted

  // business FF
  factFindBusinessDetails: '/dashboard/fact-find/business-details',
  factFindBusinessKeyMembers: '/dashboard/fact-find/key-members',
  factFindBusinessFinancialInformation: '/dashboard/fact-find/financial-information',
  factFindBusinessLoans: '/dashboard/fact-find/loans',
  factFindBusinessAssetsPremise: '/dashboard/fact-find/assets-premise',
  factFindBusinessProfessionalAdvisors: '/dashboard/fact-find/professional-advisors',
  factFindBusinessPensions: '/dashboard/fact-find/pensions',
  factFindBusinessCovers: '/dashboard/fact-find/covers',
  factFindBusinessEmployeeBenefits: '/dashboard/fact-find/employee-benefits',
  clientDetailsAI: '/dashboard/fact-find/client-details-ai',
  clientDetailsCheckList: '/dashboard/fact-find/client-details-check-list',

  // client info
  clientInfo: '/dashboard/client-info',
  clientInfoZetaAI: '/dashboard/client-info/zeta-ai',
  clientInfoZetaAIAdvise: '/dashboard/client-info/zeta-ai-advise',
  clientInfoOverview: '/dashboard/client-info/overview',
  clientInfoSecureMessage: '/dashboard/client-info/secure-message',
  clientInfoInitialMeetingSummary: '/dashboard/client-info/initial-meeting-summary',
  clientInfoClientInteractionHub: '/dashboard/client-info/client-interaction-hub',
  clientInfoBilling: '/dashboard/client-info/billing',
  clientInfoDocuments: '/dashboard/client-info/documents',
  clientInfoHouseHold: '/dashboard/client-info/household',
  clientInfoAdvisoryActions: '/dashboard/client-info/advisory-actions',
  clientInfoConflictResolution: '/dashboard/client-info/conflict-resolution',
  clientInfoActivityLog: '/dashboard/client-info/activity-log',
  clientInfoAskZeta: '/dashboard/client-info/ask-zeta',
  clientInfoBusinessReviews: '/dashboard/client-info/business-reviews',
  clientInfoBusinessProfile: '/dashboard/client-info/business-profile',
  clientInfoPlans: '/dashboard/client-info/plans',
  clientInfoFactFind: '/dashboard/client-info/discovery',
  clientInfoKYCAML: '/dashboard/client-info/kyc-aml',
  clientInfoGoalsAndTimeline: '/dashboard/client-info/financial-planning-workspace',
  clientInfofinancialPlanningTask: '/dashboard/client-info/financial-planning-workspace',
  clientInfoinvestmentPlanning: '/dashboard/client-info/investment-planning',
  clientInfoinvestmentPlanningSummary: '/dashboard/client-info/investment-planning-summary',
  clientInfoprotectionPlanning: '/dashboard/client-info/protection-planning',
  clientInfoprotectionPlanningSolution: '/dashboard/client-info/solution',
  clientInfocustomTask: '/dashboard/client-info/custom-task',
  clientInfofactFindTasks: '/dashboard/client-info/fact-find-tasks',
  clientInfoReports: '/dashboard/client-info/reports',

  //workplace routes
  clientInfoWorkplaceTasksActivities: '/dashboard/client-info/workplace/tasks-activities',
  clientInfoWorkplaceDiscovery: '/dashboard/client-info/workplace/fact-find',
  clientInfoWorkplaceParaplanning: '/dashboard/client-info/workplace/paraplanning',
  clientInfoWorkplaceRecommendation: '/dashboard/client-info/workplace/recommendation',
  clientInfoWorkplaceReview: '/dashboard/client-info/review',
  clientInfoWorkplaceExecution: '/dashboard/client-info/workplace/execution',
  clientInfoWorkplaceMeetingNotes: '/dashboard/client-info/meeting-notes',
  clientInfoWorkplacePlansNew: '/dashboard/client-info/plans-new',
  clientInfoFinancialPlanningWorkspace: '/dashboard/client-info/financial-planning-workspace',
  clientInfoRetirementPlanningWorkspace: '/dashboard/client-info/financial-planning-workspace',
  clientInfoWorkplacePlansSetup: '/dashboard/client-info/plans-new/setup',
  // from, these will be deleted

  // PROFILE SETUP ROUTES
  profileSetup: '/profile-setup',
  organisationProfile: '/profile-setup/organisation-profile',
  userManagement: '/profile-setup/user-management',
  myProfile: '/profile-setup/my-profile',
  changePassword: '/profile-setup/change-password',
  modelPortfolios: '/profile-setup/model-portfolios',
  riskAssessment: '/profile-setup/risk-assessment',
  financialPlanning: '/profile-setup/financial-planning',
  adviceTemplates: '/profile-setup/advice-templates',
  factFindConfiguration: '/profile-setup/fact-find-configuration',
  crm: '/profile-setup/crm',
  certificationsAndExpertise: '/profile-setup/certifications-and-expertise',
  certificationsAndExpertiseCert: '/profile-setup/certifications-and-expertise/certifications',
  certificationsAndExpertiseExpertise: '/profile-setup/certifications-and-expertise/expertise',
  certificationsAndExpertiseProfessionalBackground: '/profile-setup/certifications-and-expertise/professional-background',
  firmProfileIncomplete: '/firm-profile-incomplete',
  billingAndInvoice: '/profile-setup/billing-and-invoice',
  documentManagement: '/profile-setup/document-management',
  feesAndChargesManagement: '/profile-setup/fees-and-charges-management',
  clientCommunication: '/profile-setup/client-communication',
  // MY-TASKS-ROUTES
  myTasks: '/dashboard/my-tasks',
  createSolution: '/dashboard/my-tasks/create-solution',
  report: '/dashboard/my-tasks/report',
  taskRTQ: '/dashboard/my-tasks/risk-questions',
  taskGDPR: '/dashboard/my-tasks/gdpr-agreement',

  meetingConfiguration: '/profile-setup/meeting-configuration',

  // from, these will be deleted
  // MEETINGS ROUTES
  availability: '/dashboard/meetings/availability',

  // Others
  forbidden: '/403',
};
